/* OAY free gift: when the cart (excluding Triblend tees) reaches the threshold,
   add one Triblend tee in the customer's size, free via the Shopify automatic
   discount "OAY Free Triblend Tee above 3500". Removes it if the cart drops. */
(function () {
  var el = document.getElementById('oay-gift-config');
  if (!el) return;
  var C;
  try { C = JSON.parse(el.textContent); } catch (e) { return; }

  // only switch on from the start time (India time), or with ?oay_gift=test
  var test = /[?&]oay_gift=test/.test(location.search) || sessionStorageGet('oayGiftTest');
  if (/[?&]oay_gift=test/.test(location.search)) sessionStorageSet('oayGiftTest', '1');
  if (!test && C.start) {
    var t = Date.parse(C.start.replace(' ', 'T') + ':00+05:30');
    if (!isNaN(t) && Date.now() < t) return;
  }

  document.documentElement.classList.add('oay-gift-on');   // shows the free-tee bar in the cart drawer
  var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var ALIAS = { '2XL': 'XXL', 'XXXL': '3XL' };
  var WAIST = {};
  String(C.waist || '').split(',').forEach(function (p) {
    var b = p.split(':'); if (b.length === 2) WAIST[b[0].trim()] = b[1].trim().toUpperCase();
  });
  var threshold = (parseFloat(C.threshold) || 3500) * 100;
  var giftVariantIds = {};
  (C.variants || []).forEach(function (v) { giftVariantIds[v.id] = v; });
  var badIds = {};
  var busy = false, again = false, timer = null;

  function sessionStorageGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessionStorageSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function sizeOf(item) {
    var vals = (item.options_with_values || []).map(function (o) { return String(o.value); });
    if (!vals.length && item.variant_title) vals = item.variant_title.split('/');
    for (var i = 0; i < vals.length; i++) {
      var v = vals[i].trim().toUpperCase();
      var m = v.match(/^(XXXL|3XL|2XL|XXL|XL|XXS|XS|S|M|L)\b/);
      if (m) return ALIAS[m[1]] || m[1];
      var n = v.match(/^(\d{2})\b/);
      if (n && WAIST[n[1]]) return WAIST[n[1]];
    }
    return null;
  }
  function isGift(item) { return item.properties && item.properties._oay_gift; }
  function isTriblend(item) { return !!giftVariantIds[item.variant_id] || (item.product_type || '') === C.type; }

  function pickSize(items) {
    var count = {};
    items.forEach(function (it) {
      var s = sizeOf(it); if (!s) return;
      count[s] = (count[s] || 0) + it.quantity;
    });
    var best = null;
    Object.keys(count).forEach(function (s) {
      if (!best || count[s] > count[best] || (count[s] === count[best] && SIZES.indexOf(s) > SIZES.indexOf(best))) best = s;
    });
    return best;
  }
  function pickVariant(size) {
    var start = SIZES.indexOf(size);
    if (start < 0) return null;
    for (var i = start; i < SIZES.length; i++) {          // their size, then next size up
      var opts = (C.variants || []).filter(function (v) { return v.size === SIZES[i] && v.avail && !badIds[v.id]; });
      if (opts.length) { opts.sort(function (a, b) { return b.qty - a.qty; }); return opts[0]; }
    }
    return null;
  }

  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-OAY-Gift': '1' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }
  function refreshCartUi() {
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (n) {
      try { document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
    });
    /* GoKwik side cart has its own refresh */
    try { if (typeof window.refreshSideCart === 'function') window.refreshSideCart(); } catch (e) {}
  }

  /* ---------- the customer's own pick ---------- */
  var state = { earned: false, current: null };
  function chosenVariant() {
    var id = parseInt(sessionStorageGet('oayGiftChoice') || '', 10);
    var v = id && giftVariantIds[id];
    return v && v.avail && !badIds[v.id] ? v : null;
  }
  function hasAnyStock() { return (C.variants || []).some(function (v) { return v.avail && !badIds[v.id]; }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  var CSS = '' +
    '.oay-gp{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:flex-end;justify-content:center;background:rgba(10,10,10,.55);font-family:DM-sans,"DM Sans",sans-serif;color:#0A0A0A}' +
    '.oay-gp[hidden]{display:none}' +
    '.oay-gp__box{background:#fff;width:100%;max-width:520px;max-height:86vh;overflow:auto;border-radius:18px 18px 0 0;padding:18px 16px calc(16px + env(safe-area-inset-bottom));box-sizing:border-box;animation:oayGpUp .25s ease-out}' +
    '@keyframes oayGpUp{from{transform:translateY(30px);opacity:0}to{transform:none;opacity:1}}' +
    '.oay-gp__top{display:flex;justify-content:space-between;align-items:flex-start;gap:12px}' +
    '.oay-gp__kick{display:inline-block;background:#29F500;color:#0A0A0A;font-size:10px;font-weight:800;letter-spacing:.12em;padding:4px 8px;border-radius:4px}' +
    '.oay-gp__h{margin:8px 0 2px;font-size:20px;line-height:1.2;font-weight:800}' +
    '.oay-gp__p{margin:0;font-size:13px;color:#555}' +
    '.oay-gp__uni{display:flex;align-items:center;gap:10px;margin:12px 0 0;padding:10px 12px;background:#0A0A0A;color:#fff;border:1px solid #29F500;border-radius:10px;font-size:13px;line-height:1.4}' +
    '.oay-gp__uni b{color:#29F500;font-weight:800}' +
    '.oay-gp__uni-i{flex:0 0 26px;height:26px;border-radius:50%;background:#29F500;color:#0A0A0A;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:800}' +
    '.oay-gp__x{flex:0 0 auto;width:36px;height:36px;border:0;border-radius:50%;background:#F1F1F1;font-size:20px;line-height:36px;cursor:pointer;color:#0A0A0A;padding:0}' +
    '.oay-gp__lbl{margin:16px 0 8px;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#364057}' +
    '.oay-gp__sizes{display:flex;flex-wrap:wrap;gap:6px}' +
    '.oay-gp__sz{min-width:48px;height:40px;padding:0 10px;border:1.5px solid #DDD;border-radius:8px;background:#fff;font:700 13px DM-sans,"DM Sans",sans-serif;color:#0A0A0A;cursor:pointer}' +
    '.oay-gp__sz[aria-pressed="true"]{border-color:#0A0A0A;background:#0A0A0A;color:#29F500}' +
    '.oay-gp__sz:disabled{opacity:.35;text-decoration:line-through;cursor:default}' +
    '.oay-gp__cols{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}' +
    '.oay-gp__col{border:1.5px solid transparent;border-radius:10px;background:none;padding:0 0 6px;cursor:pointer;text-align:center;font:600 11px/1.2 DM-sans,"DM Sans",sans-serif;color:#0A0A0A}' +
    '.oay-gp__col img{display:block;width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:8px;background:#EDEDEB;margin-bottom:5px}' +
    '.oay-gp__col[aria-pressed="true"]{border-color:#29F500;box-shadow:0 0 0 2px #29F500 inset}' +
    '.oay-gp .oay-gp__go{margin:16px 0 0!important;width:100%!important;height:50px!important;padding:0 16px!important;border:0!important;border-radius:10px!important;background:#0A0A0A!important;color:#29F500!important;font:800 15px DM-sans,"DM Sans",sans-serif!important;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;letter-spacing:0!important;text-transform:none!important;cursor:pointer;line-height:1!important}' +
    '.oay-gp__go:disabled{opacity:.4;cursor:default}' +
    '.oay-gp__note{margin:10px 0 0;font-size:11.5px;color:#777;text-align:center}' +
    '.oay-gpill{position:fixed;left:12px;bottom:calc(14px + env(safe-area-inset-bottom));z-index:2147483500;display:flex;align-items:center;gap:8px;max-width:calc(100% - 24px);border:0;border-radius:999px;background:#0A0A0A;color:#fff;padding:9px 14px 9px 10px;font:600 12px DM-sans,"DM Sans",sans-serif;box-shadow:0 6px 18px rgba(0,0,0,.25);cursor:pointer}' +
    '.oay-gpill[hidden]{display:none}' +
    '.oay-gpill.is-off{display:none!important}' +
    '.oay-gpill.is-mini{padding:7px;gap:0}' +
    '.oay-gpill.is-mini > span:not(.oay-gpill__dot){display:none}' +
    '.oay-gpill.is-mini .oay-gpill__dot{width:28px;height:28px;font-size:16px}' +
    '.oay-gpill b{color:#29F500;font-weight:800}' +
    '.oay-gpill__dot{width:22px;height:22px;border-radius:50%;background:#29F500;color:#0A0A0A;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:13px}' +
    '@media (min-width:750px){.oay-gp{align-items:center}.oay-gp__box{border-radius:18px}.oay-gp__cols{grid-template-columns:repeat(5,minmax(0,1fr))}.oay-gpill{left:20px;bottom:20px}}';

  var ui = null, pick = { size: null, id: null };
  function buildUi() {
    if (ui) return ui;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    var wrap = document.createElement('div');
    wrap.className = 'oay-gp'; wrap.hidden = true;
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-labelledby', 'oay-gp-h');
    wrap.innerHTML = '<div class="oay-gp__box">' +
      '<div class="oay-gp__top"><div><span class="oay-gp__kick">UNLOCKED</span>' +
      '<h2 class="oay-gp__h" id="oay-gp-h">' + esc(C.picker_title || 'Your free Triblend tee') + '</h2>' +
      '<p class="oay-gp__p">' + esc(C.picker_text || 'Your cart is above ₹3,500. Pick any size and colour, it’s free.') + '</p>' +
      '<p class="oay-gp__uni"><span class="oay-gp__uni-i" aria-hidden="true">♥</span><span><b>These are unisex.</b> Pick one for your sister, wife or friends.</span></p></div>' +
      '<button type="button" class="oay-gp__x" aria-label="Close">&times;</button></div>' +
      '<div class="oay-gp__lbl">Size</div><div class="oay-gp__sizes" data-s></div>' +
      '<div class="oay-gp__lbl">Colour</div><div class="oay-gp__cols" data-c></div>' +
      '<button type="button" class="oay-gp__go" data-go>Make this my free tee</button>' +
      '<p class="oay-gp__note">One free tee per order. It stays free while your cart is above ₹' + esc((threshold / 100).toLocaleString('en-IN')) + '.</p>' +
      '</div>';
    document.body.appendChild(wrap);
    var pill = document.createElement('button');
    pill.type = 'button'; pill.className = 'oay-gpill'; pill.hidden = true;
    document.body.appendChild(pill);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) closePicker(); });
    wrap.querySelector('.oay-gp__x').addEventListener('click', closePicker);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !wrap.hidden) closePicker(); });
    wrap.querySelector('[data-go]').addEventListener('click', function () {
      if (!pick.id) return;
      sessionStorageSet('oayGiftChoice', String(pick.id));
      sessionStorageSet('oayGiftPending', '1');
      sessionStorageSet('oayGiftDeclined', '');
      closePicker();
      schedule(10);
    });
    pill.addEventListener('click', openPicker);
    // taps inside the picker must not reach the theme's "click outside closes the cart" handler
    ['click', 'mousedown', 'pointerdown', 'touchstart', 'touchend'].forEach(function (ev) {
      wrap.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: ev.indexOf('touch') === 0 });
    });
    ui = { wrap: wrap, pill: pill };
    return ui;
  }
  function sizesInStock() {
    return SIZES.filter(function (s) { return (C.variants || []).some(function (v) { return v.size === s && v.avail && !badIds[v.id]; }); });
  }
  function drawPicker() {
    var u = buildUi();
    var sBox = u.wrap.querySelector('[data-s]'), cBox = u.wrap.querySelector('[data-c]');
    var inStock = sizesInStock();
    sBox.innerHTML = SIZES.filter(function (s) { return (C.variants || []).some(function (v) { return v.size === s; }); }).map(function (s) {
      var ok = inStock.indexOf(s) > -1;
      return '<button type="button" class="oay-gp__sz" data-size="' + s + '" aria-pressed="' + (s === pick.size) + '"' + (ok ? '' : ' disabled') + '>' + s + '</button>';
    }).join('');
    var cols = (C.variants || []).filter(function (v) { return v.size === pick.size && v.avail && !badIds[v.id]; })
      .sort(function (a, b) { return b.qty - a.qty; });
    if (cols.length && !cols.some(function (v) { return v.id === pick.id; })) pick.id = cols[0].id;
    cBox.innerHTML = cols.map(function (v) {
      return '<button type="button" class="oay-gp__col" data-id="' + v.id + '" aria-pressed="' + (v.id === pick.id) + '">' +
        (v.img ? '<img src="' + esc(v.img) + '" alt="" loading="lazy">' : '') + esc(v.colour || '') + '</button>';
    }).join('');
    u.wrap.querySelector('[data-go]').disabled = !pick.id;
    sBox.onclick = function (e) { var b = e.target.closest('[data-size]'); if (!b || b.disabled) return; pick.size = b.getAttribute('data-size'); pick.id = null; drawPicker(); };
    cBox.onclick = function (e) { var b = e.target.closest('[data-id]'); if (!b) return; pick.id = parseInt(b.getAttribute('data-id'), 10); drawPicker(); };
  }
  function openPicker() {
    var u = buildUi();
    var cur = state.current || chosenVariant();
    var inStock = sizesInStock();
    pick.size = cur ? cur.size : (inStock[0] || null);
    pick.id = cur ? cur.id : null;
    drawPicker();
    // the cart drawer closes on any tap outside it (focus trap); pause that while the picker is up
    try {
      var d = document.getElementById('mini-cart');
      if (d && d.hasAttribute('open') && d.focusTrap && d.focusTrap.pause) { d.focusTrap.pause(); pausedTrap = d; }
    } catch (e) {}
    u.wrap.hidden = false;
    var x = u.wrap.querySelector('.oay-gp__x'); if (x) x.focus();
  }
  window.oayGift = { open: function () { openPicker(); } };
  var pausedTrap = null;
  function closePicker() {
    if (ui) ui.wrap.hidden = true;
    if (pausedTrap) {
      try { if (pausedTrap.hasAttribute('open') && pausedTrap.focusTrap.unpause) pausedTrap.focusTrap.unpause(); } catch (e) {}
      pausedTrap = null;
    }
  }
  function renderPill() {
    if (!state.earned) { if (ui) ui.pill.hidden = true; return; }
    var u = buildUi(), v = state.current;
    u.pill.innerHTML = '<span class="oay-gpill__dot" aria-hidden="true">+</span>' +
      (v ? '<span>Free tee: <b>' + esc(v.size) + ' · ' + esc(v.colour || '') + '</b> · Change</span>'
         : '<span><b>Free tee unlocked</b> · Pick yours</span>');
    u.pill.setAttribute('aria-label', v ? 'Free tee: ' + v.size + ' ' + (v.colour || '') + '. Change' : 'Free tee unlocked. Pick yours');
    u.pill.hidden = false;
    pillFit();
  }

  /* The pill floats above everything, so keep it out of the way: hidden while any drawer, sheet,
     popup or modal is open, and shrunk to its round "+" once the shopper scrolls. */
  var OVERLAYS = 'drawer-content[open], quick-buy-drawer[open], cart-drawer[open], .sheet.show, .sheet-bg.show, ' +
    '.size-chart-drawer.active, .bp-quickview-overlay.active, [class*="modal"].active, [class*="modal"].is-open, .oay-gp:not([hidden])';
  function overlayOpen() {
    var r = document.documentElement, b = document.body;
    if (r.classList.contains('lock-all') || r.classList.contains('lock-mobile')) return true;
    if (b && (b.style.overflow === 'hidden' || r.style.overflow === 'hidden')) return true;
    /* GoKwik's side cart lives in a shadow root and only exists while it is open */
    var gk = document.querySelector('shadow-dom-container');
    if (gk && gk.shadowRoot && gk.shadowRoot.querySelector('.sidecart, .overlay')) return true;
    return !!document.querySelector(OVERLAYS);
  }
  function pillFit() {
    if (!ui || !ui.pill || ui.pill.hidden) return;
    ui.pill.classList.toggle('is-off', overlayOpen());
    ui.pill.classList.toggle('is-mini', (window.scrollY || 0) > 120);
  }
  /* GoKwik side cart: its free-tee line only has a size dropdown, so add a button there that
     opens our picker (size AND colour). GoKwik re-renders the cart often, so keep re-adding it. */
  var GK_BTN_CSS = '.oay-gk-change{display:inline-flex;align-items:center;gap:4px;margin-top:8px;padding:5px 10px;' +
    'border:0;border-radius:999px;background:#29F500;color:#0A0A0A;font:700 11px/1.2 DM-sans,"DM Sans",sans-serif;cursor:pointer;' +
    'white-space:nowrap;width:max-content;-webkit-tap-highlight-color:transparent}' +
    '.oay-gk-change svg{flex:0 0 auto}' +
    '.oay-gk-actions{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-top:8px}' +
    '.oay-gk-actions .oay-gk-change{margin-top:0}' +
    '.oay-gk-remove{display:inline-flex;align-items:center;gap:4px;padding:5px 10px;border:1px solid #CFCFCF;border-radius:999px;background:#fff;color:#555;font:600 11px/1.2 DM-sans,"DM Sans",sans-serif;cursor:pointer;white-space:nowrap}' +
    '.oay-gk-remove:disabled{opacity:.5}' +
    '.oay-gk-readd{display:flex;align-items:center;justify-content:center;gap:6px;width:calc(100% - 16px);margin:8px;padding:10px 12px;border:1.5px dashed #29F500;border-radius:10px;background:#0A0A0A;color:#fff;font:600 13px DM-sans,"DM Sans",sans-serif;cursor:pointer}' +
    '.oay-gk-readd b{color:#29F500}';
  function gkGiftButton() {
    var host = document.querySelector('shadow-dom-container');
    var sr = host && host.shadowRoot;
    if (!sr) return;
    var items = sr.querySelectorAll('.item.free-product');
    /* gift removed by the customer: offer it back at the top of the cart */
    var back = sr.querySelector('.oay-gk-readd');
    var wantBack = !items.length && state.earned && sessionStorageGet('oayGiftDeclined') === '1';
    var firstItem = sr.querySelector('.item');
    if (wantBack && !back && firstItem && firstItem.parentElement) {
      back = document.createElement('button');
      back.type = 'button';
      back.className = 'oay-gk-readd';
      back.innerHTML = '\ud83c\udf81 <b>Free gift unlocked</b> \u00b7 Add it back';
      back.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPicker(); });
      firstItem.parentElement.insertBefore(back, firstItem);
    } else if (!wantBack && back) { back.remove(); }
    if (!sr.getElementById('oay-gk-gift-style')) {
      var st = document.createElement('style');
      st.id = 'oay-gk-gift-style';
      st.textContent = GK_BTN_CSS;
      sr.appendChild(st);
    }
    if (!items.length) return;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.querySelector('.oay-gk-change')) continue;
      var where = it.querySelector('.details') || it;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oay-gk-change';
      b.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>Change size / colour';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        openPicker();
      });
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'oay-gk-remove';
      rm.setAttribute('aria-label', 'Remove free gift');
      rm.innerHTML = '<svg width="11" height="11" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12"/></svg>Remove';
      rm.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        sessionStorageSet('oayGiftDeclined', '1');
        rm.disabled = true; rm.textContent = 'Removing\u2026';
        schedule(10);
      });
      var row = document.createElement('div');
      row.className = 'oay-gk-actions';
      row.appendChild(b); row.appendChild(rm);
      where.appendChild(row);
    }
  }
  setInterval(gkGiftButton, 600);

  window.addEventListener('scroll', pillFit, { passive: true });
  setInterval(pillFit, 300);
  try {
    var mo = new MutationObserver(pillFit);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  } catch (e) {}

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    api('/cart.js').then(function (res) {
      var cart = res.data || {};
      var items = cart.items || [];
      var gifts = items.filter(isGift);
      var paid = items.filter(function (it) { return !isGift(it); });
      var qualifying = paid.filter(function (it) { return !isTriblend(it); });
      var total = qualifying.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || 0); }, 0);
      var hasPaidTee = paid.some(isTriblend);           // a tee already in the cart becomes the free one
      var want = null;
      var earned = total >= threshold && !hasPaidTee;
      // a gift tee already in the cart (maybe re-sized in the GoKwik cart's dropdown) is respected,
      // unless the customer just picked another one in our picker
      var inCart = gifts.length && giftVariantIds[gifts[0].variant_id];
      var pending = sessionStorageGet('oayGiftPending');
      if (inCart && !pending) sessionStorageSet('oayGiftChoice', String(gifts[0].variant_id));
      if (pending) sessionStorageSet('oayGiftPending', '');
      /* the customer removed the free gift: don't put it back until they pick one again */
      var declined = sessionStorageGet('oayGiftDeclined') === '1';
      if (earned && !declined) {
        var chosen = (inCart && !pending) ? inCart : chosenVariant();   // the customer's own pick wins
        if (chosen) want = chosen;
        else {
          var size = pickSize(qualifying);
          want = size ? pickVariant(size) : null;
        }
      }
      state.earned = earned && hasAnyStock();
      state.current = want;
      // first time the gift unlocks this visit: open the picker (even if no auto size was found)
      var firstTime = state.earned && !declined && !gifts.length && !sessionStorageGet('oayGiftSeen');
      var ops = Promise.resolve();
      var changed = false;
      // drop gifts that are wrong, extra, or no longer earned
      gifts.forEach(function (g, i) {
        var keep = want && i === 0 && g.variant_id === want.id;
        if (!keep) {
          changed = true;
          ops = ops.then(function () { return api('/cart/change.js', { id: g.key, quantity: 0 }); });
        } else if (g.quantity !== 1) {
          changed = true;
          ops = ops.then(function () { return api('/cart/change.js', { id: g.key, quantity: 1 }); });
        }
      });
      var haveRight = want && gifts.length && gifts[0].variant_id === want.id;
      if (want && !haveRight) {
        changed = true;
        ops = ops.then(function () {
          var props = { _oay_gift: '1' };
          if (C.label) props[C.label_key || 'Free gift'] = C.label;
          return api('/cart/add.js', { items: [{ id: want.id, quantity: 1, properties: props }] }).then(function (r) {
            if (!r.ok) { badIds[want.id] = 1; again = true; }
          });
        });
      }
      return ops.then(function () {
        if (changed) refreshCartUi();
        renderPill();
        if (firstTime) { sessionStorageSet('oayGiftSeen', '1'); openPicker(); }
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; schedule(500); }
    });
  }
  // check twice: once right after a change, and again a few seconds later,
  // because other cart rules (e.g. the max-2-per-item limit) can trim the cart afterwards
  var timer2 = null;
  function schedule(ms) {
    clearTimeout(timer); timer = setTimeout(reconcile, ms || 1200);   // pause lets remove-then-add swaps finish
    clearTimeout(timer2); timer2 = setTimeout(reconcile, 3000);
  }
  // last check when the customer heads to checkout or opens the cart
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button, a');
    if (t && /checkout|cart/i.test((t.className || '') + ' ' + (t.getAttribute('href') || '') + ' ' + (t.getAttribute('name') || '') + ' ' + (t.id || ''))) schedule(50);
  }, true);

  // watch every cart change made by the theme or the GoKwik cart
  var CART_RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = init && init.headers && (init.headers['X-OAY-Gift'] || (init.headers.get && init.headers.get('X-OAY-Gift')));
      var p = origFetch.apply(this, arguments);
      if (!mine && CART_RX.test(url)) p.then(function () { schedule(); }, function () {});
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RX.test(String(url))) this.addEventListener('loadend', function () { schedule(); });
    return origOpen.apply(this, arguments);
  };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(300); });
  window.addEventListener('pageshow', function () { schedule(300); });
  schedule(800);
})();
